<template>
<div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form
            class="content_block"
            label-width="100px"
            size="small"
            label-position="right"
            @search="getList('init')"
            @reset="handleReset"
            :keepOpenedRow="2">
            <el-form-item label="合同状态" :span="24">
              <check-tag v-model="advancedForm.state" @change="() => getList('init')">
                <check-tag-item
                  :value="i.value"
                  :key="i.value"
                  v-for="i in executionStatusGroup"
                  :label="`${i.label}(${i.count || 0})`"
                ></check-tag-item>
              </check-tag>
            </el-form-item>
            <el-form-item label="合同编号">
              <el-input
                v-model.trim="advancedForm.pcCode"
                clearable
                placeholder="请输入合同编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户抬头">
              <el-input
                v-model.trim="advancedForm.unit"
                clearable
                placeholder="请输入客户抬头"
              ></el-input>
            </el-form-item>
            <el-form-item label="收款状态">
              <el-select
                v-model.trim="advancedForm.payState"
                clearable
                placeholder="请选择收款状态"
                @change="getList('init')"
              >
                <el-option
                  v-for="item in collectionStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发货状态">
              <el-select
                v-model.trim="advancedForm.receivingSts"
                clearable
                placeholder="请选择发货状态"
                @change="getList('init')"
              >
                <el-option
                  v-for="item in deliveryStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户联系人">
              <el-input
                v-model.trim="advancedForm.saleContractCustomerContact"
                clearable
                placeholder="请输入客户联系人"
              ></el-input>
            </el-form-item>
            <el-form-item label="开票状态">
              <el-select
                v-model.trim="advancedForm.billingState"
                clearable
                placeholder="请选择开票状态"
                @change="getList('init')"
              >
                <el-option
                  v-for="(item, index) in billingStatusOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收货人">
              <el-input
                v-model.trim="advancedForm.receiverName"
                clearable
                placeholder="请输入收货人"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人手机">
              <el-input
                v-model.trim="advancedForm.receiverPhone"
                clearable
                placeholder="请输入收货人手机"
              ></el-input>
            </el-form-item>
            <el-form-item label="签订日期(起)">
              <el-date-picker
                v-model="advancedForm.signStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择签订日期(起)"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="签订日期(止)">
              <el-date-picker
                v-model="advancedForm.signEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择签订日期(止)"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="变更状态">
              <el-select
                v-model.trim="advancedForm.changeState"
                clearable
                placeholder="请选择变更状态"
                @change="getList('init')"
              >
                <el-option
                  v-for="item in changeStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model.trim="advancedForm.remark"
                clearable
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            rowKey="id"
            @refresh="handleReset"
            @fullScreen="handleFullScreen">
            <template #buttons>
              <el-button v-if="$withPermission('gongxutong:sale:contract:export')" type="primary" size="mini" @click="handleExport">导出</el-button>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="saleContract" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
            <div slot="action" slot-scope="_, row">
              <a v-if="$withPermission('gongxutong:sale:contract:detail')" @click="() => operate('detail', row)">查看</a>
              <a v-if="row.state === 6 && $withPermission('gongxutong:sale:contract:audit')" style="margin-left: 8px" @click="() => operate('review', row)">审核</a>
              <a v-if="row.changeState === 1 && $withPermission('gongxutong:sale:contract:audit')" style="margin-left: 8px" @click="() => operate('change', row)">变更审核</a>
            </div>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>
<script>
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import { queryPage, queryStateInfo, exportSaleContract } from '@/api/saleContract';
import setTableCols from './configs';
import {
  executionStatusGroup,
  collectionStatusOptions,
  deliveryStatusOptions,
  changeStatusOptions,
  billingStatusOptions,
} from '@/model/saleContract';

export default {
  name: 'sale_contract',
  components: {
    xzTable,
    tableHeaderConfiguration,
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        // advancedSearch: true,
        custom: true,
      };
    },
  },
  data () {
    return {
      disabledList: ['state', 'pcCode', 'unit'],
      columnList: [
        ...setTableCols.call(this),
      ],
      baseLists: [
        ...setTableCols.call(this),
      ],
      dataList: [],
      executionStatusGroup,
      advancedForm: {
        state: '',
        receiverName: '',
        receiverPhone: '',
        remark: '',
      },
      collectionStatusOptions,
      deliveryStatusOptions,
      changeStatusOptions,
      billingStatusOptions,
      scrollHeight: 600,
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created () {
    if (this.$route.query.status || this.$route.query.status === 0) {
      this.advancedForm.state = this.$route.query.status + '';
    }

    this.getList();
    this.getSaleContractCount();
  },
  methods: {
    updateColumnList (columnList) {
      this.columnList = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    handleReset () {
      for (let key in this.advancedForm) {
        this.advancedForm[key] = '';
      }

      this.total = 0;
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
      };

      this.getList();
    },
    getList (type) {
      if (type === 'init') {
        this.pagination = {
          total: 0,
          pageNum: 1,
          pageSize: 10,
        };
      }

      let { pageSize, pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];

      queryPage({ ...this.advancedForm, orderBy, pageSize, pageNum, flag: 1 }).then(
        ({ body }) => {
          this.dataList = body.list;
          this.total = +body.total || 0;
        },
      );
    },
    operate (type, row) {
      let path = '/salesManagement/saleContract/detail';

      if (type !== 'detail') {
        path = '/salesManagement/saleContract/review';
      }

      this.$router.push({
        path: path,
        query: {
          id: row.id,
          type,
        },
      });
    },
    getSaleContractCount () {
      queryStateInfo().then(({ body }) => {
        for (let v of this.executionStatusGroup) {
          v.count = body[v.en];
        }
      });
    },
    handleExport () {
      let { pageSize, pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];
      exportSaleContract({ ...this.advancedForm, orderBy, pageSize, pageNum, flag: 1 }).then(({data})=>{
        const downloadData = {
          data: data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileTitle: `销售合同_${Date.now()}`,
        };
        this.downBinaryStreamHandle(downloadData);
      });
    },
    downBinaryStreamHandle ({ data, type, fileTitle }) {
      let blob = new Blob([data], { type });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileTitle;
      document.querySelectorAll('body')[0].appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>
<style lang='scss' scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
}
/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
